import { FC, useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from '../../hooks'
import { fetchInventoriesWithPagination, InventoryFilter, InventoryQueryParams } from "../../redux/InventorySlice"
import { MYSVG } from "../../shared/Helpers/MYSVG"
import { Pagination } from "../../shared/pagination/pagination"
import { Searchbar } from "../Property/Searchbar"

const InventoryWrapper: FC = (prop: any) => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const inventory = useAppSelector(state => state.inventory)

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);

    const [search, setSearch] = useState("");
    const searchRef = useRef(null);

    const [inventoryFilter, setInventoryFilter] = useState<InventoryFilter | null>(null);

    const [sortCol, setSortCol] = useState(null)
    const [sortDir, setSortDir] = useState(null)


    useEffect(() => {

        const resultParams: InventoryQueryParams = {
            sorting: sortDir && sortCol ? {
                column: sortCol,
                direction: sortDir
            } : undefined,
            paginator: {
                page: currentPage,
                pageSize: pageSize
            },
            searchTerm: search,
            filter: undefined,
        }
        dispatch(fetchInventoriesWithPagination(resultParams))

    }, [currentPage, pageSize, search, dispatch, sortDir, sortCol])

    const handleNavigateEditPage = (id: number) => {
        navigate("../edit/" + id)
    }
    const handleNavigateCreatePage = () => {
        navigate("../create")
    }
    return (
        <>
            <Searchbar
                search={search}
                setSearch={setSearch}
                setCurrentPage={setCurrentPage}
                searchRef={searchRef}
            />
            <div className='shadow-lg shadow-sky-100 my-3 mb-2 bg-white p-12 '>
                <div className=" grid grid-cols-1 md:grid-cols-3 gap-1 ">
                    <button className='gap-2 hover:bg-gray-100 border border-gray-300 hover:shadow-md text-gray-700 px-2 py-1 text-sm align-middle font-semibold rounded-sm flex items-center'
                        onClick={() => handleNavigateCreatePage()}>
                        <MYSVG path="/assets/svg/plus.svg" svgClassName="h-6 w-6" className="cursor-pointer" /> Yeni Tesis Ekle</button>
                    {!inventory.loading && inventory.data?.items && inventory.data?.items.map((inventory, index) => (
                        <div
                            key={"inventory" + index}
                            className="flex flex-nowrap place-items-center px-2 py-1 border border-gray-300 cursor-pointer rounded-sm hover:bg-gray-100 hover:border-gray-400 "
                            onClick={() => handleNavigateEditPage(inventory.id)}>
                            <h1 className="flex flex-nowrap place-items-center text-sm sm:text-md font-semibold text-gray-700">
                                <MYSVG path="/assets/svg/build.svg" className="mr-2" svgClassName="h-5 w-5" />
                                {inventory.title}
                            </h1>
                            <div className="flex-grow"> </div>
                            <div className="text-xs font-normal ml-2 whitespace-nowrap text-gray-500">{inventory.active_channels && inventory.active_channels.length + "Kn "} [{inventory.property_priority}]</div>

                        </div>
                    ))
                    }
                    {inventory.loading && <div>
                        <svg aria-hidden="true" className="mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                    </div>}
                </div>
                <div className="flow-root items-center mt-5 ">
                    <div className='tfoot d-flex flex-md-stack float-left'>
                        <div className='d-flex flex-md-stack'>
                            <select onChange={(e: any) => setPageSize(e.target.value)} className=" border py-1 pr-6 pl-1 bg-slate-100 rounded font-normal text-gray-600" aria-label="Select example" value={pageSize}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            <span className='paginateDescription'></span>
                        </div>
                    </div>
                    <div>
                        <div>
                            <Pagination
                                className="pagination-bar"
                                currentPage={currentPage}
                                totalCount={inventory.data?.total}
                                pageSize={pageSize}
                                siblingCount={1} onPageChange={(page: number) => setCurrentPage(page)
                                } />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default InventoryWrapper;
